<div *ngIf="loading" class="loading">
<div class="slider">
  <div class="line"></div>
  <div class="subline inc"></div>
  <!-- <div class="subline dec"></div> -->
</div>
</div>
<router-outlet></router-outlet>
<ra-error *ngIf="showErrors" [fixed]="true"></ra-error>
